var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcOutlineChevronDown24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.442 13.775a.625.625 0 0 1-.884 0L3.725 7.942a.625.625 0 1 1 .884-.884L10 12.45l5.391-5.39a.625.625 0 0 1 .884.883l-5.833 5.833Z",
  fill: "#8B97A7"
})));
export default SvgIcOutlineChevronDown24X24;